// src/components/LogoGlow.js
import React from "react";
// import "./glowlogo.css";
import companylogo from '../../../assets/kmpslogo.png'

const LogoGlow = () => {
    return (
        <div className="logo-container">
            <div className="right-side">
                <img src={companylogo} alt="Right Side" className="glowing-part" />
            </div>
        </div>
    );
};

export default LogoGlow;
